import { Select } from 'antd';
import React from 'react';
import { useMasterSubjectsSelector, useMasterUserSelector } from '../../../../redux/selector';
import { QA_TICKET_STATUS, ROLE_NAME, STATUS_RATE } from 'utils/data';
import { useNavigate } from 'react-router-dom';

const { Option } = Select;

interface FormData {
  onData?: any;
  onFilter?: any;
  showOpenTicket?: boolean
}

const QnaFilter: React.FC<FormData> = ({showOpenTicket}) => {
  const user = useMasterUserSelector();
  const subject = useMasterSubjectsSelector();

  const navi = useNavigate();

  const handleFilterSubject = (value: any) => {
    navi(`/qna-tickets/tickets/${value}`);
  };

  const handleFilterStatus = async (value: any) => {
    let baseUrl = `status&${value}`;
    if (value === 'all') baseUrl = value;
    navi(`/qna-tickets/tickets/${baseUrl}`);
  };
  const handleFilterStatusRate = async (value: any) => {
    let baseUrl = `status-rate&${value?.toLowerCase()}`;
    if (value === 'all') baseUrl = value;
    navi(`/qna-tickets/tickets/${baseUrl}`);
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    let input = event.currentTarget.value;
    if (event.key === 'Enter') {
      if (input !== '') {
        navi(`/qna-tickets/tickets/search&${input}`);
      } else {
        navi(`/qna-tickets/tickets/all`);
      }
    }
  };
  return (
    <div className="flex flex-wrap items-start p-2 box-border w-[100%] bg-white z-0 mb-2 rounded-sm">
      <div className="flex flex-wrap flex-grow min-w-0">
        <div className="mt-2 mr-2">
          <Select
            id="subject"
            placeholder="Môn - Tất cả"
            className="min-w-40"
            defaultValue={'all'}
            onChange={(value) => handleFilterSubject(value)}
          >
            <Option value="all">Môn - Tất cả</Option>
            {subject?.map((subject) => <Option value={subject.id}>{subject?.name}</Option>)}
          </Select>
        </div>
        <div className="mt-2 mr-2">
          <Select id="startTime" defaultValue="all" className="min-w-40">
            <Option value="all">Thời gian bắt đầu - Tất cả</Option>
          </Select>
        </div>
        <div className="mt-2 mr-2">
          <Select id="status" defaultValue={'all'} className="min-w-40" onChange={(value) => handleFilterStatus(value)}>
            <Option value="all">Trạng thái - Tất cả</Option>
            <Option value={QA_TICKET_STATUS.OPEN}>Mở</Option>
            <Option value={QA_TICKET_STATUS.PROCESS}>Đang xử lý</Option>
            <Option value={QA_TICKET_STATUS.REPORT}>Report</Option>
            <Option value={QA_TICKET_STATUS.CLOSE}>Kết thúc</Option>
          </Select>
        </div>
        {user && user?.role === ROLE_NAME.ROLE_ADMIN ? (
          <div className="mt-2 mr-2">
            <Select id="ctv" defaultValue="Tất cả" className="min-w-40">
              <Option value="Tất cả">Tên CTV - Tất cả</Option>
              {/* Add more options as needed */}
            </Select>
          </div>
        ) : null}
        {user && user?.role === ROLE_NAME.ROLE_ADMIN ? (
          <div className="mt-2 mr-2">
            <Select
              id="rating"
              defaultValue="all"
              className="min-w-40"
              onChange={(value) => handleFilterStatusRate(value)}
            >
              <Option value="all">Đánh giá - Tất cả</Option>
              <Option value={STATUS_RATE.GOOD}>Hài lòng</Option>
              <Option value={STATUS_RATE.NOT_GOOD}>Không hài lòng</Option>
            </Select>
          </div>
        ) : null}
      </div>

      <div className="flex items-center mt-2">
        <input
          type="text"
          id="search"
          placeholder="Nhập từ khoá tìm kiếm"
          className="block min-w-60 max-w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          onKeyDown={handleKeyPress}
        />
      </div>
    </div>
  );
};

export default QnaFilter;
